var exports = {
  "r": "ActiveNowTab.module__cooldownHint___NkNVNG",
};

module.exports = exports;
